<template>
  <TarjetaDatos titulo="Conductor Habitual">
    <Campo2L :valor="conductor.nombre" />
    <Campo2L
      :valor="conductor.fecCarnet | dateDDMMYYYY"
      etiqueta="Fecha Carnet"
    />
    <Campo2L
      :valor="conductor.fecNacimiento | dateDDMMYYYY"
      etiqueta="Fecha Nacimiento"
    />
    <Campo2L :valor="conductor.tipoCarnet" etiqueta="Tipo Carnet" />
  </TarjetaDatos>
</template>

<script>
import emptyObj from "@/util/EmptyObject.js";
export default {
  props: {
    conductor: {
      type: Object,
      required: false,
      default: emptyObj
    }
  }
};
</script>

<style lang="scss" scoped></style>
